export const SALES_ORDER_LINE_CONSTRAINTS = {
    salesOrder: { label: 'Sales order' },
    product: { label: 'Product' },
    qty: { label: 'Quantity' },
    unitPrice: { label: 'Unit price' },
    uom: { label: 'Unit of measure' },
    lineType: { label: 'Line type' },
    note: { label: 'Notes', max: 5_000 },
};
//# sourceMappingURL=constraints.js.map